module.exports = __webpack_public_path__ + "img/top.6b4c830e.png";